'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbChatLines() {
    return {
        restrict: 'A',
        scope: {
            isKassabonPresent: '=',
            showKassabon: '='
        },
        controller: 'chatLinesController',
        controllerAs: 'chatLinesController',
        link: function link($scope, $element) {
            $scope.chatLinesController.setElement($element[0]);
            $scope.chatLinesController.init();

            $scope.chatLinesController.checkChatLine = function () {
                var lastLine = $element.children().last()[0];
                if ($scope.isKassabonPresent) {
                    if ($scope.chatLinesController.checkLineContainsNeedle(lastLine)) {
                        $scope.showKassabon = true;
                        $scope.$apply();
                    }
                }
            };
        }
    };
}

exports.default = cbChatLines;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/cb-chat-lines.directive.js
// module id = 866
// module chunks = 0